// extracted by mini-css-extract-plugin
export var pillWrapper = "_x8-0";
export var showOverflow = "_x8-1";